import type { Locale } from "@/i18n/locales";

import { howItWorks as en } from "./en/how-it-works";
import { howItWorks as de } from "./de/how-it-works";
import type { HowItWorksContent } from "./types";

const HOW_IT_WORKS: Readonly<Record<Locale, HowItWorksContent>> = { en, de };

export function howItWorksFor(locale: Locale): HowItWorksContent {
  return HOW_IT_WORKS[locale];
}
